import { getMomentTz, useShiftNavigator } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-enterprise";
import { get } from "lodash-es";
import {
	LinkCellRenderer,
	ManualIconCellRenderer,
	NumericCellRenderer,
} from "../../../../controls/ag-grid/components/ButtonCellRenderer";
type Props = {};
const moment = getMomentTz();
export const useTableData = ({}: Props) => {
	const { shiftInfo } = useShiftNavigator();
	const shiftId = get(shiftInfo, "CurrentShiftId", null);
	const columns: ColDef[] = [
		{
			field: "HeatName",
			headerName: "Heat",
			cellRenderer: (params: any) => {
				return LinkCellRenderer({
					...params,
					link: `/meltshop-heats/${shiftId}?heatId=${params.data.HeatId}`,
				});
			},
			flex: 1,
			minWidth: 66,
		},
		{
			field: "GradeName",
			headerName: "Grade",
			flex: 1,
			minWidth: 80,
		},
		{
			field: "LadleName",
			headerName: "Ladle",
			flex: 1,
			minWidth: 57,
		},
		{
			field: "HeatOrder",
			headerName: "Order",
			flex: 1,
			minWidth: 59,
		},
		{
			field: "MoldSizeName",
			headerName: "Mold Size",
			flex: 1,
			minWidth: 60,
			wrapHeaderText: true,
		},
		{
			field: "LadleOpen",
			headerName: "Open",
			cellRenderer: LinkCellRenderer,
			cellRendererParams: { linkProperty: "HeatNameLink" },
			flex: 1,
			minWidth: 61,
			valueGetter: (params) =>
				params.data.LadleOpen
					? moment(params.data?.LadleOpen).format("HH:mm")
					: "",
		},
		{
			field: "LadleClose",
			headerName: "Close",
			flex: 1,
			minWidth: 61,
			valueGetter: (params) =>
				params.data.LadleClose
					? moment(params.data?.LadleClose).format("HH:mm")
					: "",
		},
		{
			field: "Duration",
			headerName: "Duration",
			flex: 1,
			minWidth: 76,
			cellRenderer: NumericCellRenderer,
			cellRendererParams: { numericFormat: "0.0" },
			cellStyle: {
				textAlign: "right",
			},
		},
		{
			field: "CastTons",
			headerName: "Tons",
			flex: 1,
			minWidth: 53,
			cellRenderer: NumericCellRenderer,
			cellRendererParams: { numericFormat: "0.0" },
			cellStyle: {
				textAlign: "right",
			},
		},
		{
			field: "ScrapTons",
			headerName: "Scrap [lbs]",
			flex: 1,
			minWidth: 60,
			cellRenderer: NumericCellRenderer,
			cellRendererParams: { numericFormat: "0" },
		},
		{
			field: "LostStrands",
			headerName: "Lost Strands",
			flex: 1,
			minWidth: 80,
			cellRenderer: NumericCellRenderer,
			cellRendererParams: { numericFormat: "0" },
			wrapHeaderText: true,
		},

		{
			field: "TrimProbeTemperature",
			headerName: "Trim Temp",
			wrapHeaderText: true,
			flex: 1,
			minWidth: 60,
		},
		{
			field: "TrimProbeOxygen",
			headerName: "Trim O2",
			flex: 1,
			minWidth: 80,
		},
		{
			field: "FirstProbeTemperature",
			headerName: "First Temp",
			flex: 1,
			minWidth: 60,
			wrapHeaderText: true,
		},
		{
			field: "LastProbeTemperature",
			headerName: "Last Temp",
			flex: 1,
			minWidth: 60,
			wrapHeaderText: true,
		},
		{
			field: "LastSuperheat",
			headerName: "Last SH",
			flex: 1,
			minWidth: 73,
			cellStyle: {
				textAlign: "right",
			},
		},
		{
			field: "IsProcessManual",
			headerName: "",
			flex: 1,
			minWidth: 34,
			maxWidth: 34,
			cellRenderer: ManualIconCellRenderer,
			cellClass: "ag-button-cell",
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "Actions",
			headerName: "",
			type: ["nonSorteable", "nonFilterable", "optionsButton"],
			flex: 1,
			minWidth: 150,
			editable: false,
		},
	];

	return { columns };
};
